import React from 'react';
import withSplashMessage from '../splashMessage/withSplashMessage';

class SplashMessageNew extends React.Component {
  state = {
    message: '',
    className: ''
  };

  render() {
    const { message, className } = this.state;
    // className 'error' or 'success' must be present for correct color background
    let classes = `splash-message-new ${className} `;
    classes += message ? 'splash-message-new--show' : '';

    return <div className={classes}>{message}</div>;
  }

  componentDidUpdate = prevProps => {
    const { messages } = this.props;
    const message = messages && messages.length > 0 ? messages[0].message : '';
    const className =
      messages && messages.length > 0 ? messages[0].className : '';

    if (messages !== prevProps.messages) {
      // Just showing the first message.  For new client dash there wouldn't ever be more than one.
      this.setState({
        message
      });

      //  Only change className if present.  Prevents removal of background color before slide up
      if (className) {
        this.setState({
          className
        });
      }
    }
  };
}

export default withSplashMessage(SplashMessageNew);



// WEBPACK FOOTER //
// ./src/components/new/SplashMessageNew.js